import * as React from 'react'
import { Dialog, Button, Icon } from '@alifd/next';
import doLog from '../../common/log';
import openXman from '../../common/xman';
import SampleDialog from './sample-dialog';
const {useState} = React;

export default function SampleLink(props: any) {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const {sampleInfo, productId, companyId, i18n} = props;
  const {skuList, samplePreferedDispatchId = ''} = sampleInfo;
  
  // 多sku支持
  if (skuList?.length > 0) {
    return <>
              <a href="#" onClick={e => {
                e.preventDefault();
                doLog(
                  '/sc.details.getSample',
                  `from=dialog&pid=${productId}`,
                );
                setIsOpen(true);
              }}>{i18n["btnGetSample"]}</a>

              <Dialog
                    title={i18n["btnGetSample.sample"]}
                    footerActions={[]}
                    visible={isOpen}
                    style={{
                      width: 840
                    }}
                    onClose={() => setIsOpen(false)}>
                      <SampleDialog {...props} onClose={() => setIsOpen(false)}/>
              </Dialog>
          </>
  }

  // 直接跳转下单
  const url = `//biz.alibaba.com/contract/SampleOrder.htm?data=[{%22productId%22:%22${productId}%22,%22dispatchLocation%22:%22${samplePreferedDispatchId}%22,%22skuId%22:%22%22}]&tracelog=from_detail_get_sample`;

  const handleClick = (e: { preventDefault: () => void; }) => {
    e.preventDefault();
    // 前置登录
    setLoading(true);
    doLog(
      '/sc.details.getSample',
      `from=order&pid=${productId}`,
    );
    openXman(() => {
      window.location.href = url
    }, ()=> {
      setLoading(false)
    })
  }

  return (
      <Button type="primary" component="a" className='bs-btn' href={url} data-domdot={`id:25853,sid:${companyId},pid:'${productId}',ext:'other=orderSample'`} loading={loading} onClick={handleClick} text>
        <Icon type="packaging"/>
        {i18n["btnGetSample"]}
      </Button>
  )
}
